import { Col, Form, Row } from "reactstrap";
import { Btn, H3, LI, UL } from "../../../../../../AbstractElements";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { AssetsVehiclesFormData, AssetsVehiclesFormErrors } from "../../../FormData";
import DollarInput from "../../../../../common/DollarInput";
import DropDown from "../../../../../common/DropDown";
import TextField from "../../../../../common/TextField";
import { Button } from "reactstrap"; // Assuming you need to import Btn and Button from reactstrap
import DecimalInput from "../../../../../common/DecimalInput";
import { useMutationRequestQuery } from "../../../../../../Hooks/useMutationRequestQuery";
import { getClientVehicleAssetsByClientIdService, getClientVehicleAssetsByIdService, insertOrUpdateClientVehicleAssetsService, softDeleteVehicleAssetsByIdService } from "../../../../../../Services/PublicPageServices";
import { useDispatch } from "react-redux";
import { setFormStatus } from "../../../../../../ReduxToolkit/Reducers/FromStatusSlice";
import { Continue } from "../../../../../../Utils/Constants";
import { setFormsData } from "../../../../../../ReduxToolkit/Reducers/FormDataSlice";
import { useGetRequestQuery } from "../../../../../../Hooks/useGetRequestQuery";
import DataTable from "react-data-table-component";
import { replaceFormData } from "../../../../../../ReduxToolkit/Reducers/FactFindDataSlice";

export default function AssetsVehicles({ activeCallBack, clientFactFindData, clientId }: any) {
    const [formData, setFormData] = useState<any>(AssetsVehiclesFormData);
    const [formErrors, setFormErrors] = useState<any>(AssetsVehiclesFormErrors);
    const [assetsPropertyData, setAssetsPropertyData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState<number | null>(null);

    const dispatch = useDispatch()

    // Validation functions
    const validateStringField = (value: string) => value.trim() !== '';
    const validateNumberField = (value: string) => value.trim() !== '';
    const validateDateField = (value: string) => value.trim() !== '';

    // Handle Error Change function to update the error state
    const handleErrorChange = (name: string, error: boolean) => {
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: error,
        }));
    };

    const {
        data: assetsProperty,
        refetch: refetchAssetsProperty,
        isLoading: assetsPropertyLoading,
        isError: assetsPropertyIsError,
    } = useGetRequestQuery(
        ['getClientVehicleAssetsByClientIdService', clientId],
        () => getClientVehicleAssetsByClientIdService(clientId),
        {
            enabled: true, // enable query only if clientId is available
        }
    );

    const {
        data: assetsPropertyFormData,
        isLoading: assetsPropertyFormDataLoading,
        isError: assetsPropertyFormDataIsError,
    } = useGetRequestQuery(
        ["getClientVehicleAssetsByIdService", selectedRowId],
        () => getClientVehicleAssetsByIdService(selectedRowId),
        {
            enabled: !!selectedRowId,
        }
    );

    useEffect(() => {
        if (assetsProperty?.data && !assetsPropertyIsError && !assetsPropertyLoading) {
            setAssetsPropertyData(assetsProperty?.data);
            dispatch(
                replaceFormData({
                    formName: "assetsVehicles",
                    formData: assetsProperty?.data,
                })
            );
        }
    }, [assetsProperty, assetsPropertyIsError, assetsPropertyLoading]);


    useEffect(() => {
        if (assetsPropertyFormData?.data && !assetsPropertyFormDataIsError && !assetsPropertyFormDataLoading) {
            if (assetsPropertyFormData?.data?.id) {
                setSelectedRowId(assetsPropertyFormData?.data?.id)
            }
            setFormData({
                vehiclesEstimatedValue: assetsPropertyFormData?.data?.estimatedValue,
                vehiclesMake: assetsPropertyFormData?.data?.make,
                vehiclesYear: assetsPropertyFormData?.data?.year,
                vehiclesCurrentLoan: assetsPropertyFormData?.data?.currentLoan,
                vehiclesLendersName: assetsPropertyFormData?.data?.lendersName,
                vehiclesInterestRate: assetsPropertyFormData?.data?.interestRate,
                vehiclesRepayment: assetsPropertyFormData?.data?.repayment,
                vehiclesRepaymentDLL: assetsPropertyFormData?.data?.frequency,
            })
        }
    }, [assetsPropertyFormData, assetsPropertyFormDataIsError, assetsPropertyFormDataLoading]);

    const { mutate: updateClientAssets, isPending: isUpdateClientAssetsPending } = useMutationRequestQuery(
        'insertOrUpdateClientVehicleAssetsService',
        insertOrUpdateClientVehicleAssetsService,
        {
            onSuccess: () => {
                toast.success("Assets vehicles information saved or updated successfully.");
                dispatch(setFormStatus({ id: '6', status: 6 }));
                // setFormErrors(AssetsVehiclesFormErrors);
                setFormData(AssetsVehiclesFormData)
                setSelectedRowId(null)
                refetchAssetsProperty()
            },
            onError: (error: any) => {
                toast.error("Failed to submit assets vehicles information");
                console.error(error);
                setFormErrors(error?.response?.data || {});
            },
        }
    );

    const {
        mutate: deleteClientAssets,
    } = useMutationRequestQuery(
        'softDeleteVehicleAssetsByIdService',
        softDeleteVehicleAssetsByIdService,
        {
            onSuccess: () => {
                toast.success("Vehicle deleted successfully.");
                refetchAssetsProperty()
                setSelectedRowId(null)
            },
            onError: (error: any) => {
                toast.error("Failed to delete Property.");
                console.error(error);
            },
        }
    );

    useEffect(() => {
        dispatch(setFormsData({
            id: '6',
            formData: formData,
        }));
    }, [formData])


    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        // Validate each vehicle field
        const vehiclesEstimatedValueValid = validateStringField(formData.vehiclesEstimatedValue);
        const vehiclesMakeValid = validateStringField(formData.vehiclesMake);
        const vehiclesYearValid = validateDateField(formData.vehiclesYear);
        const vehiclesCurrentLoanValid = validateNumberField(formData.vehiclesCurrentLoan);
        const vehiclesLendersNameValid = validateStringField(formData.vehiclesLendersName);
        const vehiclesInterestRateValid = validateNumberField(formData.vehiclesInterestRate);
        const vehiclesRepaymentValid = validateNumberField(formData.vehiclesRepayment);
        const vehiclesRepaymentDLLValid = validateStringField(formData.vehiclesRepaymentDLL);

        const isValid =
            vehiclesEstimatedValueValid &&
            vehiclesMakeValid &&
            vehiclesYearValid &&
            vehiclesCurrentLoanValid &&
            vehiclesLendersNameValid &&
            vehiclesInterestRateValid &&
            vehiclesRepaymentValid &&
            vehiclesRepaymentDLLValid;

        // Set errors based on validation
        setFormErrors({
            vehiclesEstimatedValue: !vehiclesEstimatedValueValid,
            vehiclesMake: !vehiclesMakeValid,
            vehiclesYear: !vehiclesYearValid,
            vehiclesCurrentLoan: !vehiclesCurrentLoanValid,
            vehiclesLendersName: !vehiclesLendersNameValid,
            vehiclesInterestRate: !vehiclesInterestRateValid,
            vehiclesRepayment: !vehiclesRepaymentValid,
            vehiclesRepaymentDLL: !vehiclesRepaymentDLLValid,
        });

        // If form is valid, proceed to the next step
        if (!isValid) {
            return;
        } else if (clientId != 0) {
            updateClientAssets(
                {
                    id: selectedRowId ? selectedRowId : "0",
                    clientId: clientId,
                    estimatedValue: formData.vehiclesEstimatedValue,
                    make: formData.vehiclesMake,
                    year: formData.vehiclesYear,
                    currentLoan: formData.vehiclesCurrentLoan,
                    lendersName: formData.vehiclesLendersName,
                    repayment: formData.vehiclesRepayment,
                    frequency: formData.vehiclesRepaymentDLL,
                    interestRate: formData.vehiclesInterestRate,
                }
            )
        }
    };

    const handleValueChange = (name: string, value: string) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };
    
    const splitDropdownValues = (dropdownValues: string) => {
        return dropdownValues ? dropdownValues.split(',').map(value => value.trim()) : [];
    };
    const handleEditClick = (id: number) => {
        setSelectedRowId(id);
    };

    const handleDeleteClick = (id: number) => {
        deleteClientAssets(id)
    };
    const zeroConfigurationTableColumns = [
        {
            name: "Action",
            cell: (row: any) => (
                <UL className="action simple-list flex-row">
                    <LI className="edit"><a onClick={() => { handleEditClick(row.id) }} href="#"><i className="icon-pencil-alt" /></a></LI>
                    <LI className="delete"><a onClick={() => { handleDeleteClick(row.id) }} href="#"><i className="icon-trash" /></a></LI>
                </UL>
            ), style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Estimated Value",
            selector: (row: any) => row["estimatedValue"],
            sortable: false,
            style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Make",
            selector: (row: any) => row["make"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Year",
            selector: (row: any) => row["year"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Current Loan",
            selector: (row: any) => row["currentLoan"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Lender's Name",
            selector: (row: any) => row["lendersName"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Repayment",
            selector: (row: any) => row["repayment"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Frequency",
            selector: (row: any) => row["frequency"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
        {
            name: "Interest Rate",
            selector: (row: any) => row["interestRate"],
            sortable: false, style: {
                minWidth: '9rem', // Home Address column width set to 9rem
            },
        },
    ];

    return (
        <>
            <Form
                style={{
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    padding: '30px',
                    backgroundColor: '#fff',
                }}
                onSubmit={handleSubmit}
            >
                {assetsPropertyData.length !== 0 ? (
                    <div
                        style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '5px',
                            backgroundColor: '#fff',
                        }}
                    >
                        <Row className='g-1 m-2'>
                            <Col xs={12} className='text-left'>
                                <H3 className='f-w-900 heading-color'>Current Vehicles</H3>
                            </Col>
                        </Row>
                        <DataTable
                            title=""
                            columns={zeroConfigurationTableColumns}
                            data={assetsPropertyData}
                            // pagination
                            responsive
                        />
                    </div>
                ) : (
                    <div style={{
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        padding: '15px',
                        backgroundColor: '#fff',
                    }} >
                        <Row className='g-3 mb-4'>
                            <Col xs={12} className='text-left'>
                                <H3 className='f-w-900 heading-color'>Current Vehicles</H3>
                            </Col>
                        </Row>
                        No vehicles have been added yet.
                    </div>
                )}
                <Row className='g-3 mt-4'>
                    <Col xs={6} className='mb-4 text-left'>
                        <H3 className='f-w-900 heading-color'>Vehicle Assets Details</H3>
                    </Col>
                    <Col xs={6} className="text-end">
                        {/* "Previous" Button */}
                        <Btn color="primary" style={{ fontSize: '18px' }} className='me-2' onClick={() => activeCallBack(2)}>
                            Previous
                        </Btn>

                        {/* "Continue" Button */}
                        <Button
                            type="button"
                            color="success"
                            onClick={() => { activeCallBack(7) }}
                            style={{ fontSize: '18px' }}
                        >
                            {Continue}
                        </Button>
                    </Col>
                </Row>

                <Row className="mt-4">
                    {/* Vehicle Fields Column */}
                    <Col sm={10} className='sm-row' >
                        <TextField
                            label="Make"
                            type="text"
                            name="vehiclesMake"
                            value={formData.vehiclesMake}
                            setValue={handleValueChange}
                            placeholder="Enter vehicle make"
                            // required={true}
                            setError={handleErrorChange}
                            errorMessage="Vehicle make is required"
                            error={formErrors.vehiclesMake}
                            design="flex"
                            maxChars={20} // Assuming you want a character limit, adjust as needed
                            passCol="col-3"
                        />

                    </Col>

                    <Col sm={10} className='sm-row' >
                        <TextField
                            label="Year"
                            type="number"
                            name="vehiclesYear"
                            value={formData.vehiclesYear}
                            setValue={handleValueChange}
                            placeholder="YYYY"
                            // required={true}
                            setError={handleErrorChange}
                            errorMessage="Year is required"
                            error={formErrors.vehiclesYear}
                            design="flex"
                            passCol="col-2"
                            maxChars={4}
                        />
                    </Col>
                    <Col sm={10} className='sm-row' >
                        <DollarInput
                            label="Estimated Value"
                            name="vehiclesEstimatedValue"
                            value={formData.vehiclesEstimatedValue}
                            setValue={handleValueChange}
                            placeholder="Enter value"
                            // required={true}
                            limit={6}
                            setError={handleErrorChange}
                            errorMessage="Estimated Value is required"
                            error={formErrors.vehiclesEstimatedValue}
                            design="flex"
                            passCol="col-2"
                        />
                    </Col>
                </Row>

                <Row className='g-3'>
                    <Col xs={12} className='mb-2 mt-4 text-left'>
                        <H3 className='f-w-900 heading-color'>Loan Details</H3>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col sm={10} className='sm-row' >
                        <DollarInput
                            label="Current Loan"
                            name="vehiclesCurrentLoan"
                            value={formData.vehiclesCurrentLoan}
                            setValue={handleValueChange}
                            placeholder="Enter loan"
                            // required={true}
                            limit={6}
                            setError={handleErrorChange}
                            errorMessage="Current Loan is required"
                            error={formErrors.vehiclesCurrentLoan}
                            design="flex"
                            passCol="col-2"
                        />
                    </Col>

                    <Col sm={10} className='sm-row' >

                        <TextField
                            label="Lenders Name"
                            type="text"
                            name="vehiclesLendersName"
                            value={formData.vehiclesLendersName}
                            setValue={handleValueChange}
                            placeholder="Enter lender's name"
                            // required={true}
                            setError={handleErrorChange}
                            errorMessage="Lender's Name is required"
                            error={formErrors.vehiclesLendersName}
                            design="flex"
                            maxChars={20}
                            passCol="col-3"
                        />
                    </Col>

                    <Col sm={10} className='sm-row' >
                        <DollarInput
                            label="Repayment"
                            name="vehiclesRepayment"
                            value={formData.vehiclesRepayment}
                            setValue={handleValueChange}
                            placeholder="Enter repayment"
                            // required={true}
                            limit={6}
                            setError={handleErrorChange}
                            errorMessage="Repayment is required"
                            error={formErrors.vehiclesRepayment}
                            design="flex"
                            passCol="col-2"
                        />
                    </Col>

                    <Col sm={10} className='sm-row' >
                        <DropDown
                            label="Frequency"
                            name="vehiclesRepaymentDLL"
                            value={formData.vehiclesRepaymentDLL}
                            setValue={handleValueChange}
                            options={splitDropdownValues(clientFactFindData ? clientFactFindData[11].dropDownValues : '')}
                            // required={true}
                            setError={handleErrorChange}
                            errorMessage="Repayment DLL is required"
                            error={formErrors.vehiclesRepaymentDLL}
                            design="flex"
                            passCol='col-3'
                        />
                    </Col>

                    <Col sm={10} className='sm-row' >

                        <DecimalInput
                            label="Interest Rate"
                            name="vehiclesInterestRate"
                            value={formData.vehiclesInterestRate}
                            setValue={handleValueChange}
                            placeholder=""
                            // required={true}
                            limit={4}
                            setError={handleErrorChange}
                            errorMessage="Interest rate is required"
                            error={formErrors.vehiclesInterestRate}
                            design="flex"
                            passCol="col-3"
                        />
                    </Col>
                </Row >
                <Button
                    disabled={isUpdateClientAssetsPending}
                    type="button"
                    color="primary"
                    onClick={handleSubmit}
                    style={{ fontSize: '18px' }}
                >
                    {isUpdateClientAssetsPending ? 'Loading . . .' : selectedRowId ? "Update Vehicle" : "Add New Vehicle"}
                </Button>
      
            </Form >
        </>
    );
}
